import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/Layout';
import PageHeader from '@/components/PageHeader';
import CtaBand from '@/components/CtaBand';
import ServiceCard from '@/components/ServiceCard';
import TrustRow from '@/components/TrustRow';
import { api } from '@/lib/api';

export default function ResidentialPage() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get('/services').then(r => setCats((r.data.categories || []).filter(c => c.slug !== 'commercial'))); }, []);
  return (
    <Layout>
      <PageHeader eyebrow="For Homeowners" title="Concierge residential services across South Florida." subtitle="From a quick handyman visit to a full luxury remodel — one trusted service for every project.">
        <TrustRow />
      </PageHeader>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cats.map(c => <ServiceCard key={c.slug} category={c} />)}
        </div>
      </section>
      <CtaBand title="Get a residential estimate in 60 seconds" />
    </Layout>
  );
}
